/* ============================================================
   Corporate Chair Systems — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Sticky Header --------------------------------------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile Nav ----------------------------------------- */
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ---- Mobile Sub-nav Accordion --------------------------- */
  document.querySelectorAll('.mobile-nav-link[data-toggle]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const sub = link.nextElementSibling;
      if (sub && sub.classList.contains('mobile-nav-sub')) {
        sub.classList.toggle('open');
        const isOpen = sub.classList.contains('open');
        sub.style.display = isOpen ? 'block' : 'none';
      }
    });
  });

  /* ---- Product Gallery ------------------------------------ */
  const mainImage = document.querySelector('.product-main-image img');
  const thumbs = document.querySelectorAll('.product-thumb');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        const src = thumb.querySelector('img')?.src;
        if (src) mainImage.src = src;
      }
    });
  });

  /* ---- Product Variant Selection -------------------------- */
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-options');
      if (group) {
        group.querySelectorAll('.variant-btn').forEach((b) => b.classList.remove('active'));
      }
      btn.classList.add('active');
    });
  });

  /* ---- Qty Control ---------------------------------------- */
  document.querySelectorAll('.qty-control').forEach((ctrl) => {
    const input = ctrl.querySelector('.qty-input');
    ctrl.querySelector('.qty-minus')?.addEventListener('click', () => {
      if (!input) return;
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    ctrl.querySelector('.qty-plus')?.addEventListener('click', () => {
      if (!input) return;
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---- Product Tabs --------------------------------------- */
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach((b) => b.classList.remove('active'));
      tabPanels.forEach((p) => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(target)?.classList.add('active');
    });
  });

  /* ---- Filter Chips --------------------------------------- */
  document.querySelectorAll('.filter-chip').forEach((chip) => {
    chip.addEventListener('click', () => {
      const group = chip.closest('.filter-bar');
      if (chip.dataset.exclusive !== undefined || !group) {
        group?.querySelectorAll('.filter-chip').forEach((c) => c.classList.remove('active'));
        chip.classList.add('active');
      } else {
        chip.classList.toggle('active');
      }
    });
  });

  /* ---- Collection Sort ------------------------------------ */
  const sortSelect = document.querySelector('.collection-sort select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---- Scroll to Top -------------------------------------- */
  const scrollTopBtn = document.getElementById('scroll-top');
  if (scrollTopBtn) {
    window.addEventListener('scroll', () => {
      scrollTopBtn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- Announcement Bar Dismiss --------------------------- */
  const annBar = document.querySelector('.announcement-bar');
  const annClose = document.querySelector('.announcement-close');
  if (annClose && annBar) {
    annClose.addEventListener('click', () => {
      annBar.style.display = 'none';
      sessionStorage.setItem('ann-dismissed', '1');
    });
    if (sessionStorage.getItem('ann-dismissed')) annBar.style.display = 'none';
  }

  /* ---- Fade-up on scroll (Intersection Observer) ---------- */
  if ('IntersectionObserver' in window) {
    const fadeEls = document.querySelectorAll('[data-fade]');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-up');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    fadeEls.forEach((el) => obs.observe(el));
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch { /* ignore */ }
  }

  /* ---- Quote Form Multi-step ------------------------------ */
  const quoteForm = document.querySelector('.quote-multistep');
  if (quoteForm) {
    const steps = quoteForm.querySelectorAll('.quote-form-step');
    const stepIndicators = document.querySelectorAll('.quote-step');
    let currentStep = 0;

    function showStep(idx) {
      steps.forEach((s, i) => {
        s.style.display = i === idx ? 'block' : 'none';
      });
      stepIndicators.forEach((s, i) => {
        s.classList.remove('active', 'done');
        if (i < idx) s.classList.add('done');
        if (i === idx) s.classList.add('active');
      });
    }

    quoteForm.querySelectorAll('[data-next]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (currentStep < steps.length - 1) { currentStep++; showStep(currentStep); }
      });
    });
    quoteForm.querySelectorAll('[data-prev]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (currentStep > 0) { currentStep--; showStep(currentStep); }
      });
    });

    showStep(0);
  }

  /* ---- Contact Form --------------------------------------- */
  const contactForm = document.querySelector('[data-contact-form]');
  if (contactForm) {
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('[type="submit"]');
      const formData = new FormData(contactForm);
      formData.append('form_type', 'contact');
      formData.append('utf8', '✓');
      try {
        const res = await fetch('/', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (res.ok) {
          contactForm.innerHTML = '<div class="form-success"><h3>Message sent!</h3><p>Thank you for your message. We\'ll be in touch within 1 business day.</p></div>';
        }
      } catch {
        if (btn) btn.textContent = 'Try again';
      }
    });
  }

  /* Init cart count on load */
  updateCartCount();

})();
